import React from "react";
import { useAuth } from "../Auth/AuthPage.jsx";
import { Avatar, Paper, Typography } from "@mui/material";

const UserAccountPage = () => {
    const { user, loggedIn } = useAuth();

    if (!loggedIn) {
        return (
            <Paper style={{ padding: 20, margin: "auto", maxWidth: 400 }}>
                <Typography variant="h6">Please log in to view your account.</Typography>
            </Paper>
        );
    }

    return (
        <Paper style={{ padding: 20, margin: "auto", maxWidth: 400 }}>
            <Avatar src={user.picture} style={{ margin: "auto", width: 80, height: 80 }} />
            <Typography variant="h5" align="center">{user.name}</Typography>
            <Typography variant="body1" align="center">{user.email}</Typography>
            <Typography variant="body2" align="center">Role: {user.role}</Typography>
        </Paper>
    );
};

export default UserAccountPage;